export default {
    couponTypeOptions: [
        {
            label: '满减券',
            value: 1
        },
        {
            label: '折扣券',
            value: 2
        },
        // {
        //     label: '分享券',
        //     value: 3
        // },
    ],
    couponSuitTypeOptions: [
        {
            label: '门票',
            value: 1
        },
        {
            label: '餐饮',
            value: 2
        },
        {
            label: '零售',
            value: 3
        },
        {
            label: '课程',
            value: 4
        }
    ],
    couponStatusOptions: [
        {
            label: '未生效',
            value: 1,
        },
        {
            label: '已生效',
            value: 2,
        },
        {
            label: '已失效',
            value: 3,
        }
    ],
    userCouponStatusOptions: [
        {
            label: '未领取',
            value: 0,
        },
        {
            label: '已领取',
            value: 1,
        },
        {
            label: '已使用',
            value: 2,
        },
        {
            label: '领取失败',
            value: 3,
        },
        {
            label: '已失效',
            value: 4,
        }
    ],
    ticketTradeStatusOptions: [
        {
            label: '待支付',
            value: 1,
        },
        {
            label: '已支付',
            value: 2,
        },
        {
            label: '支付失败',
            value: 3,
        },
        {
            label: '退款中',
            value: 4,
        },
        {
            label: '部分退款',
            value: 5,
        },
        {
            label: '全部退款',
            value: 6,
        },
        {
            label: '已关闭',
            value: 7,
        },
    ],
    retialGoodsStatusOptions: [
        {
            label: '待提货',
            value: 0,
        },
        {
            label: '已提货',
            value: 1,
        },
        {
            label: '已退货',
            value: 2,
        },
        {
            label: '超时待提货',
            value: -1,
        }
    ],
    partyTypeOpitons: [
        {
            label: '生日',
            value: '生日'
        },
        {
            label: '毕业',
            value: '毕业'
        },
        {
            label: '聚会',
            value: '聚会'
        },
        {
            label: '其他',
            value: '其他'
        },
    ],
    partyOrderStatusOpitons: [
        {
            label: '未归档',
            value: 1
        },
        {
            label: '已取消',
            value: 2
        },
        {
            label: '已归档',
            value: 3
        },
    ],
    depositCollectionTypeOptions: [
        {
            label: '定金',
            value: '定金'
        },
        {
            label: '尾款',
            value: '尾款'
        },
        {
            label: '进度款',
            value: '进度款'
        }
    ],
    fullpayCollectionTypeOptions: [
        {
            label: '全款',
            value: '全款'
        }
    ],
    payModeOptions: [
        {
            label: '支付宝',
            value: 1
        },
        {
            label: '微信',
            value: 2
        },
        {
            label: 'POS机',
            value: 3
        },
        {
            label: '现金',
            value: 4
        },
    ],
    payModeStrOptions: [
        {
            label: '支付宝',
            value: '支付宝'
        },
        {
            label: '微信',
            value: '微信'
        },
        {
            label: 'POS机',
            value: 'POS机'
        },
        {
            label: '现金',
            value: '现金'
        },
        {
            label: '对公银行卡转账',
            value: '对公银行卡转账'
        },
    ],
    refundModeStrOptions: [
        {
            label: '财务银行卡转账',
            value: '财务银行卡转账'
        },
        {
            label: '支付宝',
            value: '支付宝'
        },
        {
            label: '微信',
            value: '微信'
        },
        {
            label: 'POS机',
            value: 'POS机'
        },
        {
            label: '现金',
            value: '现金'
        }
    ],
    partySellTypeOptions: [
        {
            label: '预付定金',
            value: '预付定金'
        },
        {
            label: '预付全款',
            value: '预付全款'
        },
        {
            label: '后付全款',
            value: '后付全款'
        }
    ],
}
